<div class="imagePreviewWrapper">
  <div class="flex-centered images" *ngFor="let slide of this.images">
    <div class="image">
      <img [src]="slide.url" alt="{{ slide.title }}" class="d-block smallImage" (click)="this.openModal(slide.url)" />
    </div>
  </div>
</div>
<markant-dialog
  *ngIf="this.dialogState"
  class="container"
  style="text-align: center; width: 600px; height: 400px"
  fullwidth="false"
  critical="true"
  [open]="true"
>
  <div class="markant-dialog">
    <div class="markant-dialog-header">
      <div></div>
      <div class="navWrapper">
        <markant-icon src="./assets/svg/chevron-left--dense.svg" class="slideButton navButton" (click)="before()">Vorheriges</markant-icon>
        <markant-icon src="./assets/svg/chevron-right--dense.svg" class="slideButton navButton" (click)="next()">Nächstes</markant-icon>
      </div>
      <div class="closeWrapper">
        <markant-icon src="./assets/svg/close--dense.svg" class="closeButton navButton" (click)="closeModal()">Schließen</markant-icon>
      </div>
    </div>
    <div class="markant-dialog-content">
      <div class="imageWrapper">
        <img [src]="this.pickedUrl" alt="" class="d-block bigImage" />
      </div>
      <div class="markant-dialog-footer"></div>
    </div>
  </div>
</markant-dialog>
